import { Spin } from "antd";
import { Suspense, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RequireAuth } from "authRoute";
import { AppLayout } from "app-layout";
import {
  History,
  LaunchDashboard,
  M2CDashboard,
  Statistics,
  AthleticsDashboard,
  Settings,
  SetPassword,
  M2cSimulation,
  ForgotPassword,
  Login,
  OTPVarification,
  Results,
  M2CDashboardSandbox,
  SimulationHistory,
  StudioDashboard,
  GolfFacilityDetail,
  PerFormanceGolfHistory,
} from "pages";

import { Analytics } from "pages/analytics";
import { InternalDashboard } from "pages/internal-dashboard";
import M2cTonal from "pages/m2c-tonal";
import { WolfDashboard } from "pages/wolf-dashboard";
import { Tickets } from "pages/tickets";
import { AnalyticsV2 } from "pages/analyticsV2";
import { SupportTicketsV2 } from "pages/support-tickets-v2";
import { BenchMarkHistory } from "pages/benchmark-history";

export function Routing() {
  const [authenticated, setAuthenticated] = useState(false);

  return (
    <Router>
      <AppLayout authenticated={authenticated}>
        <Suspense
          fallback={
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Spin spinning />
            </div>
          }
        >
          <Routes>
            <Route path="/set-password" element={<SetPassword />} />
            <Route
              path="/reset-user-password"
              element={<div>Set password here</div>}
            />
            <Route
              path="/reset-user-email"
              element={<div>Set Email here</div>}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp-verification" element={<OTPVarification />} />
            <Route
              path="/"
              element={<Login setAuthenticated={setAuthenticated} />}
            />
            <Route
              path="/m2c-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <M2CDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-golf-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <History />
                </RequireAuth>
              }
            />

            <Route
              path="/simulation-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <SimulationHistory />
                </RequireAuth>
              }
            />
            <Route
              path="/benchmark-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <BenchMarkHistory />
                </RequireAuth>
              }
            />

            <Route
              path="/user-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <History />
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-golf-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Statistics />
                </RequireAuth>
              }
            />

            <Route
              path="/launch-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <LaunchDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-launch-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Statistics />
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-launch-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <History />
                </RequireAuth>
              }
            />

            <Route
              path="/athletics-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <AthleticsDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-athletics-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <History />
                </RequireAuth>
              }
            />

            <Route
              path="/settings"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Settings />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-analytics"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <AnalyticsV2 />
                </RequireAuth>
              }
            />
            {/* <Route
              path="/m2c-analytics2"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Analytics />
                </RequireAuth>
              }
            /> */}
            <Route
              path="/m2c-analytics-statistics"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <WolfDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-analytics-tickets"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Tickets />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-analytics-tickets2"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <Tickets /> */}
                  <SupportTicketsV2 />
                </RequireAuth>
              }
            />

            <Route
              path="/internal-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <InternalDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-athletics-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Statistics />
                </RequireAuth>
              }
            />
            <Route
              path="/simulation-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <M2cSimulation />
                </RequireAuth>
              }
            />
            <Route
              path="/tonal-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <M2cTonal />
                </RequireAuth>
              }
            />
            {/* <Route
              path="/pg-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <History variant="pg-history" />
                </RequireAuth>
              }
            /> */}

            <Route
              path="/pg-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <PerFormanceGolfHistory />
                </RequireAuth>
              }
            />

            <Route
              path="/results"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Results />
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-sandbox-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <M2CDashboardSandbox />
                </RequireAuth>
              }
            />
            <Route
              path="/m2c-sandbox-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <History /> */}
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-sandbox-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <Statistics /> */}
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-studio-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <StudioDashboard />
                </RequireAuth>
              }
            />

            <Route
              path="/golf-facility-detail/:licenseId"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <GolfFacilityDetail />
                </RequireAuth>
              }
            />
          </Routes>
        </Suspense>
      </AppLayout>
    </Router>
  );
}
